/**
 * https://stackoverflow.com/questions/18650168/convert-blob-to-base64
 * @param blob
 * @returns
 */
const blobToBase64 = (blob: Blob) => {
  return new Promise(
    (resolve: (value: string | ArrayBuffer | null) => void, _) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    }
  );
};

export default blobToBase64;
